import { useEffect, useRef, type InputHTMLAttributes } from "react";

type TextProps = Omit<InputHTMLAttributes<HTMLInputElement>, "type"> & { autoFocusOnMount?: boolean };

export function EmailInput({ autoFocusOnMount = false, className, autoComplete, ...props }: TextProps) {
  const ref = useRef<HTMLInputElement>(null);

  useEffect(() => {
    if (!autoFocusOnMount) return;
    const id = window.setTimeout(() => ref.current?.focus(), 60);
    return () => window.clearTimeout(id);
  }, [autoFocusOnMount]);

  return (
    <input
      {...props}
      ref={ref}
      type="text"
      inputMode="email"
      autoComplete={autoComplete ?? "email"}
      autoCapitalize="none"
      autoCorrect="off"
      spellCheck={false}
      enterKeyHint="next"
      name={props.name ?? "email"}
      className={`mobile-text-input${className ? ` ${className}` : ""}`}
    />
  );
}

export function OtpInput({ autoFocusOnMount = true, className, autoComplete, ...props }: TextProps) {
  const ref = useRef<HTMLInputElement>(null);

  useEffect(() => {
    if (!autoFocusOnMount) return;
    const id = window.setTimeout(() => ref.current?.focus(), 60);
    return () => window.clearTimeout(id);
  }, [autoFocusOnMount]);

  return (
    <input
      {...props}
      ref={ref}
      type="text"
      inputMode="numeric"
      pattern="[0-9]*"
      maxLength={6}
      autoComplete={autoComplete ?? "one-time-code"}
      autoCapitalize="none"
      autoCorrect="off"
      spellCheck={false}
      enterKeyHint="done"
      name={props.name ?? "one-time-code"}
      className={`otp-input mobile-text-input${className ? ` ${className}` : ""}`}
    />
  );
}
